import { TranslationService } from "../../../../../services/TranslationService";
import { AIBillingAlertSettings } from "../../../../../services/AIBillingService";
import { formatPercentage } from "../AIBillingFormat";
import { showAIBillingRequestBalanceModal } from "./AIBillingContactModal";

const AIBillingAlertBox = ({
  settings
}: {
  settings: AIBillingAlertSettings;
}) => {
  const { translate } = TranslationService;

  if (!settings.enabled) {
    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          background: "#fafafa",
          borderRadius: 8,
          padding: "14px 16px",
          fontSize: "0.8125rem",
          color: "#666"
        }}
      >
        {translate.AIAlertDisabled}
      </div>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #f3cf74",
        background: "#fff8e1",
        borderRadius: 8,
        padding: "14px 16px",
        fontSize: "0.8125rem",
        lineHeight: 1.55
      }}
    >
      {translate.AIAlertText.replace(
        "{0}",
        formatPercentage(settings.consumedPercentageThreshold)
      )}
      <br />
      <strong>{settings.email}</strong>
      <br />
      <button
        type="button"
        className="btn btn-link p-0"
        style={{ fontSize: "0.8125rem", fontWeight: 500 }}
        onClick={showAIBillingRequestBalanceModal}
      >
        {translate.AIRequestBalance}
      </button>
    </div>
  );
};

export default AIBillingAlertBox;
